import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DpUtilsService } from 'digitup-lib/dist/digitup-lib';
import * as pako from 'pako';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class HttpResponseInterceptor implements HttpInterceptor {

  constructor(private utils: DpUtilsService, private translate: TranslateService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map(event => {
        if (event instanceof HttpResponse) {
          if (event.body?.type === 'Buffer') {
            const decompressedBody = pako.inflate(event.body.data, { to: 'string' });
            return event.clone({ body: JSON.parse(decompressedBody) });
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status !== 404) {

          if (error?.error?.message) {
            this.utils.showToast({ message: error.error.message, cssClass: 'danger' });
          } else {
            this.utils.showToast({ message: this.translate.instant('errors.internal_error'), cssClass: 'danger' });
          }
        }

        return throwError(error);
      })
    );
  }

}
